export type MarketsFeedPhase = 'loading' | 'initialError' | 'staleError' | 'empty' | 'ready';

export interface MarketsFeedQueryState {
  readonly isPending: boolean;
  readonly isPlaceholderData: boolean;
  readonly isError: boolean;
}

/**
 * Classify the feed without treating a failed request as an empty response.
 * Rows from a previous query stay visible while the SDK keeps them as
 * placeholder data during a sort/filter replacement.
 */
export function resolveMarketsFeedPhase(
  query: MarketsFeedQueryState,
  ids: readonly string[],
): MarketsFeedPhase {
  if (query.isPending || query.isPlaceholderData) {
    return ids.length > 0 ? 'ready' : 'loading';
  }
  if (ids.length > 0) {
    return query.isError ? 'staleError' : 'ready';
  }
  return query.isError ? 'initialError' : 'empty';
}
